import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { hot } from "../common/data";
import { Helmet } from "react-helmet";


export const Hot = () => {
    const navigate = useNavigate();
    const [visibleCount, setVisibleCount] = useState(8);


    const showMore = () => {
        setVisibleCount(hot.length);
    }

    return (
        <>
            <Helmet>
                <title>Top Luxury Projects in Noida & Greater Noida | Investycoons</title>
                <meta
                    name="description"
                    content="Explore residential & commercial real estate in Noida, Mumbai, Goa & more. Verified listings, top builders, 0% brokerage. Book your site visit today."
                />
            </Helmet>
            <div className="w-full px-4 py-10 bg-gray-100 sm:px-6 lg:px-20">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 uppercase text-center mb-6">
                        Trending Projects in  <span className="text-green-600"> Prime Locations</span>
                    </h2>
                    <p className="text-base sm:text-lg text-gray-600 leading-relaxed text-justify mx-auto mb-12">
                        Explore Investycoons handpicked premium residential projects featuring luxury apartments, high-rise towers, and gated communities in the most sought-after sectors of Noida, Greater Noida, and Yamuna Expressway. These are the top ongoing and ready-to-move-in projects by renowned builders like Gaur, Godrej, Prestige, Sobha, SKA, Purvanchal, and ATS, offering excellent connectivity, modern amenities, and strong investment potential.
                    </p>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-8">HOT HIGHLIGHTS</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {hot.slice(0, visibleCount).map((data, index) => (
                            <div
                                key={index}
                                className="relative flex flex-col bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105 cursor-pointer"
                                onClick={() => navigate(`${data.route}`)}
                            >
                                <img
                                    src={data.img}
                                    alt={data.name}
                                    className="w-full h-60 sm:h-56 md:h-52 object-cover"
                                />
                                <span className="absolute top-4 right-4 bg-gradient-to-r from-blue-500 to-green-500 text-white px-3 py-1 rounded-full text-xs font-medium shadow-md">
                                    {data.type}
                                </span>
                                <div className="p-4">
                                    <p className="text-lg font-semibold text-gray-900 uppercase mb-1">{data.name}</p>
                                    <p className="text-gray-600 text-sm mb-2">{data.location}</p>
                                    <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full shadow-md">
                                        {[1, 15].includes(data.id)
                                            ? "Price Revealing Soon"
                                            : `Starts from ₹ ${data.price}`}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {visibleCount < hot.length && (
                        <div className="flex justify-center mt-10">
                            <button
                                onClick={showMore}
                                className="px-6 py-2 bg-green-500 text-white font-medium rounded-lg shadow-md hover:bg-green-600 transition duration-300"
                            >
                                See More
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}